<!DOCTYPE html>
<html>
  <head>
    <meta charset="utf-8">
    <title>File Viewer</title>
  </head>
  <div style="display: flex;">
    <mat-checkbox [(ngModel)]="splitByName">
      <span>Split</span>
    </mat-checkbox>
    @if (currentJob.storage_cost != null) {
      <div style="margin-top: 2px; margin-left: 40%">Storage Cost: {{currentJob.storage_cost.toFixed(4)}}</div>
    }
  </div>
  @if (!splitByName) {
    <div class="card" style="margin: 15px 15px; background-color: #f3f3f3;">
      <!-- <h1 style="margin-left: 7%; color:#2196f3">File Viewer</h1> -->
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <input type="text" [(ngModel)]="name" placeholder="Search by Name" style="text-align: center; margin-left: 5%; height: 30px;" (change)="updateFilteredFiles()"/>
        <mat-paginator class="paginator" [pageSizeOptions]="[5, 20, 30, 50]"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          [length]="totalItems"
          (page)="onPageChange($event)"
          style="background-color: #f3f3f3;">
        </mat-paginator>
      </div>
      <div style="width: 100%; display: flex; justify-content: center; align-items: center;">
        <table class="files-list styled-table">
          <thead>
            <tr>
              <th (click)="sortByName()">File Name
                @if (nameOrder=='ascending') {
                  <i class="zmdi zmdi-chevron-up"></i>
                }
                @if (nameOrder=='descending') {
                  <i class="zmdi zmdi-chevron-down"></i>
                }
              </th>
              <th (click)="sortByIter()">Iteration
                @if (iterOrder=='ascending') {
                  <i class="zmdi zmdi-chevron-up"></i>
                }
                @if (iterOrder=='descending') {
                  <i class="zmdi zmdi-chevron-down"></i>
                }
              </th>
              <th (click)="sortByType()">Type
                @if (typeOrder=='ascending') {
                  <i class="zmdi zmdi-chevron-up"></i>
                }
                @if (typeOrder=='descending') {
                  <i class="zmdi zmdi-chevron-down"></i>
                }
              </th>
              <th (click)="sortBySize()">Size
                @if (sizeOrder=='ascending') {
                  <i class="zmdi zmdi-chevron-up"></i>
                }
                @if (sizeOrder=='descending') {
                  <i class="zmdi zmdi-chevron-down"></i>
                }
              </th>
            </tr>
          </thead>
          <tbody>
            @for (file of pagedFiles; track file; let i = $index) {
              <tr class="files-list-entry">
                <td class="filename">{{ file.name }}</td>
                <td class="fileiter">{{ file.iteration }}</td>
                <td class="filetype">{{ file.type }}</td>
                <td class="filesize">{{ file.size.toPrecision(4) + file.unit }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
  @if (splitByName && splitReady) {
    <div class="card" style="margin: 15px 15px; background-color: #f3f3f3;">
      @for (name of names; track name) {
        <div>
          @if (name2Files.get(name).length > 0) {
            <div>
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <mat-label style="font-size: large;">{{name}}</mat-label>
                <input type="text" [(ngModel)]="name2Name[name]" placeholder="Search By Name" style="text-align: center; margin-left: 5%; height: 30px;" (change)="updateSplitFilteredFiles(name)"/>
                <mat-paginator class="paginator" [pageSizeOptions]="[5, 20, 30, 50]"
                  [pageSize]="name2Misc.get(name).pageSize"
                  [pageIndex]="name2Misc.get(name).pageIndex"
                  [length]="name2Misc.get(name).totalSize"
                  (page)="onSplitPageChange($event,name)"
                  style="background-color: #f3f3f3;">
                </mat-paginator>
              </div>
              <div style="width: 100%; display: flex; justify-content: center; align-items: center;">
                <table class="files-list styled-table">
                  <thead>
                    <tr>
                      <th (click)="sortSplitByName(name)">File Name
                        @if (name2Misc.get(name).nameOrder=='ascending') {
                          <i class="zmdi zmdi-chevron-up"></i>
                        }
                        @if (name2Misc.get(name).nameOrder=='descending') {
                          <i class="zmdi zmdi-chevron-down"></i>
                        }
                      </th>
                      <th (click)="sortSplitByIter(name)">Iteration
                        @if (name2Misc.get(name).iterOrder=='ascending') {
                          <i class="zmdi zmdi-chevron-up"></i>
                        }
                        @if (name2Misc.get(name).iterOrder=='descending') {
                          <i class="zmdi zmdi-chevron-down"></i>
                        }
                      </th>
                      <th (click)="sortSplitByType(name)">Type
                        @if (name2Misc.get(name).typeOrder=='ascending') {
                          <i class="zmdi zmdi-chevron-up"></i>
                        }
                        @if (name2Misc.get(name).typeOrder=='descending') {
                          <i class="zmdi zmdi-chevron-down"></i>
                        }
                      </th>
                      <th (click)="sortSplitBySize(name)">Size
                        @if (name2Misc.get(name).sizeOrder=='ascending') {
                          <i class="zmdi zmdi-chevron-up"></i>
                        }
                        @if (name2Misc.get(name).sizeOrder=='descending') {
                          <i class="zmdi zmdi-chevron-down"></i>
                        }
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (file of name2Misc.get(name).pagedFiles; track file; let i = $index) {
                      <tr class="files-list-entry">
                        <td class="filename">{{ file.name }}</td>
                        <td class="fileiter">{{ file.iteration }}</td>
                        <td class="filetype">{{ file.type }}</td>
                        <td class="filesize">{{ file.size.toPrecision(4) + file.unit }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</html>
